import type {
  DisableMessageType,
  Maintenance,
} from '../../context/MaintenanceProvider';

export const isSupportedLanguage = (
  lang: string,
): lang is keyof DisableMessageType =>
  lang === 'en' || lang === 'id' || lang === 'th';

export const getMessageFromMaintenance = (
  language: string,
  maintenance?: Maintenance,
): string | undefined => {
  if (!maintenance) {
    return undefined;
  }

  const languageAvailable = Object.keys(maintenance.disableMessage);

  if (languageAvailable.includes(language) && isSupportedLanguage(language)) {
    return maintenance.disableMessage[language];
  }

  return maintenance.disableMessage.en;
};
